import { render, staticRenderFns } from "./AddBlockAndPrivacy.vue?vue&type=template&id=5d79c606&"
import script from "./AddBlockAndPrivacy.vue?vue&type=script&lang=js&"
export * from "./AddBlockAndPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports